/**
 * Control relay
 * - used in Charleroi
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class ControlRelay extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'controlRelay',
        x: 0,
        y: 0,
        width: 40,
        height: 40,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    // TODO: bit 0 = red, bit 1 = blue
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    // logic is upside down here
    // control relay (balize) is active when there is no voltage - bit0 is 0
    if (status.active === 1) {
      this.modifyShape('controlRelay', 'fill', 'red')
    } else if (status.active === 0) {
      this.modifyShape('controlRelay', 'fill', 'green')
    } else {
      this.modifyShape('controlRelay', 'fill', Color.offlineGray)
    }
  }
}
